import React, { useEffect, useState } from "react";
import axios from "axios";
import UpdateContactPage from "./UpdateContactPage";
import { config } from "../../../config";

const apiUrl = config.apiUrl;

const ViewContactPage = () => {
  const [contactPage, setContactPage] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingContact, setEditingContact] = useState(null);

  const [formData, setFormData] = useState({
    phone: "",
    email: "",
    address: "",
    headline: "",
    paragraph: "",
  });

  // Fetch contact page details from API
  useEffect(() => {
    const fetchContactPage = async () => {
      try {
        const response = await axios.get(`${apiUrl}/contactpages`);
        setContactPage(response.data.contactPages[0]);
        setFormData(response.data.contactPages[0]);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching contact page details:", err);
        setLoading(false);
        setError("Failed to load contact page details.");
      }
    };

    fetchContactPage();
  }, []);

    // Handle Input Changes
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };


    // Handle Edit Click
const handleEditClick = (contactPage) => {
  // ইডিট মোডে থাকলে ফর্ম ডেটা সেট করুন
  setEditingContact(contactPage.id);

  setFormData({
    phone: contactPage.phone,
    email: contactPage.email,
    address: contactPage.address,
    headline: contactPage.headline,
    paragraph: contactPage.paragraph,
  });
};


 
// Handle Form Submit
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    await axios.put(`${apiUrl}/contactpagesupdate/${editingContact}`, formData);
    alert("Contact page updated successfully");

    // Update the local contactPage object
    setContactPage((prev) => ({
      ...prev,
      ...formData,
    }));

    // Exit editing mode
    setEditingContact(null);
  } catch (err) {
    console.error("Error updating contact page:", err);
    setError("An error occurred while updating the contact page.");
  }
};






  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Contact Page</h2>
      {error && <p className="text-red-500">{error}</p>}
      {!editingContact ? (
        <div>
          <table className="table-auto w-full text-left">
            <tbody>
              <tr>
                <th className="border px-4 py-2">Phone</th>
                <td className="border px-4 py-2">{contactPage.phone}</td>
              </tr>
              <tr>
                <th className="border px-4 py-2">Email</th>
                <td className="border px-4 py-2">{contactPage.email}</td>
              </tr>
              <tr>
                <th className="border px-4 py-2">Address</th>
                <td className="border px-4 py-2">{contactPage.address}</td>
              </tr>
              <tr>
                <th className="border px-4 py-2">Headline</th>
                <td className="border px-4 py-2">{contactPage.headline}</td>
              </tr>
              <tr>
                <th className="border px-4 py-2">Paragraph</th>
                <td className="border px-4 py-2">{contactPage.paragraph}</td>
              </tr>
            </tbody>
          </table>
          <button
            onClick={() => handleEditClick(contactPage)}
            className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mt-4"
          >
            Edit
          </button>
        </div>
      ) : (
        <UpdateContactPage
          formData={formData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          error={error}
        />
      )}
    </div>
  );
};

export default ViewContactPage;
